import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ExternalLink, Megaphone } from 'lucide-react';

const AdBanner = ({ ad, className = "", position = "default" }) => {
 // Don't render if ad is not enabled or doesn't exist
 if (!ad || !ad.ad_enabled) {
 return null;
 }

 // Position-based styling
 const positionStyles = {
 top: "mb-6",
 middle: "my-6",
 bottom: "mt-6",
 default: "my-6"
 };

 const handleAdClick = () => {
 if (ad.ad_link_url) {
 window.open(ad.ad_link_url, '_blank', 'noopener,noreferrer');
 }
 };

 return (
 <Card className={`${positionStyles[position]} ${className} border-2 border-blue-200 dark:border-blue-800 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 shadow-md hover:shadow-lg transition-shadow`}>
 <CardContent className="p-4 md:p-6">
 <div className="flex items-start gap-4">
 {/* Ad Icon/Image */}
 {ad.ad_image_url ? (
 <img
 src={ad.ad_image_url}
 alt={ad.ad_title || "Advertisement"}
 className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0"
 onError={(e) => {
 e.target.style.display = 'none';
 }}
 />
 ) : (
 <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center flex-shrink-0">
 <Megaphone className="w-8 h-8 md:w-10 md:h-10 text-white" />
 </div>
 )}

 {/* Ad Content */}
 <div className="flex-1 min-w-0">
 <div className="flex items-start justify-between gap-3">
 <div className="flex-1">
 {ad.ad_title && (
 <h3 className="text-base md:text-lg font-bold text-blue-900 dark:text-blue-100 mb-1">
 {ad.ad_title}
 </h3>
 )}
 {ad.ad_content && (
 <p className="text-sm md:text-base text-blue-700 dark:text-blue-300 mb-3">
 {ad.ad_content}
 </p>
 )}
 </div>
 
 {/* CTA Button */}
 {ad.ad_link_url && (
 <Button
 onClick={handleAdClick}
 size="sm"
 className="bg-blue-600 hover:bg-blue-700 text-white whitespace-nowrap flex-shrink-0"
 >
 {ad.ad_link_text || "Learn More"}
 <ExternalLink className="w-3 h-3 md:w-4 md:h-4 ml-2" />
 </Button>
 )}
 </div>
 </div>
 </div>

 {/* Sponsored Label */}
 <div className="mt-3 pt-3 border-t border-blue-200 dark:border-blue-700">
 <p className="text-xs text-blue-600 dark:text-blue-400 font-medium">
 📢 Sponsored Content
 </p>
 </div>
 </CardContent>
 </Card>
 );
};

export default AdBanner;
